// Components
import Textarea from '../../../atoms/Textarea/Textarea';

// Utils
import cn from '../../../../utils/cn';

// Styles
import styles from './TextareaField.module.css';

/**
 * BatchActionTextareaInput - Textarea input component for batch actions
 * @param {object} props
 * @param {string} [props.value] - Current textarea value
 * @param {(value: string) => void} props.onChange - Change handler
 * @param {string} [props.name] - Input name attribute
 * @param {boolean} [props.disabled] - Whether textarea is disabled
 * @param {boolean} [props.required] - Whether textarea is required
 * @param {string} [props.error] - Validation error
 * @param {string} [props.className] - Additional CSS classes
 * @param {number} [props.maxLength] - Maximum character length
 * @param {number} [props.rows=3] - Number of rows for textarea
 * @param {(e: React.FocusEvent<HTMLTextAreaElement>) => void} [props.onBlur] - Blur handler
 * @param {(e: React.KeyboardEvent<HTMLTextAreaElement>) => void} [props.onKeyDown] - Key down handler
 * @param {'default' | 'light' | 'table'} [props.theme = 'light'] - Theme of the textarea
 * @returns {JSX.Element} BatchActionTextareaInput component
 */
function TextareaField({
  value = '',
  onChange,
  name,
  disabled = false,
  required = false,
  error = '',
  className = '',
  maxLength,
  rows = 3,
  onBlur,
  onKeyDown,
  theme = 'light',
}) {
  /**
   * Handle textarea change
   * @param {React.ChangeEvent<HTMLTextAreaElement>} e
   */
  const handleChange = (e) => {
    const newValue = e.target.value;
    onChange(newValue);
  };

  return (
    <div className={cn([styles.wrapper, styles[theme], className])}>
      <Textarea
        value={value || ''}
        onChange={handleChange}
        name={name}
        disabled={disabled}
        required={required}
        hasError={Boolean(error)}
        maxLength={maxLength}
        rows={rows}
        className={styles.textarea}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
      />

      {error && (
        <div className={styles.error} role="alert">
          {error}
        </div>
      )}
    </div>
  );
}

export default TextareaField;
